export default "__VITE_ASSET__BS_dB0yp__"